export default {
  USER_MGMT_LIST_REQUEST: 'APP/USER_MGMT/USER_MGMT_LIST_REQUEST',
  USER_MGMT_LIST_SUCCESS: 'APP/USER_MGMT/USER_MGMT_LIST_SUCCESS',
  USER_MGMT_LIST_ERROR: 'APP/USER_MGMT/USER_MGMT_LIST_ERROR',
};
